import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import CustomSelect from 'components/CustomSelect';
import Pagination from 'components/Pagination';
import FilterSearch from 'components/FilterSearch';
import BoxDetail from './modals/BoxDetail';
import CreateBox from './modals/CreateBox';

import { GET, httpOk } from 'helpers/api';
import useDidMountEffect from 'components/useDidMountEffect';


function Production() {
    const { t } = useTranslation()

    const [boxDetailModal, setBoxDetailModal] = useState({ show: false, id: '' })
    const [createBoxModal, setCreateBoxModal] = useState({ show: false, id: '' })

    const initFilterData = {
        page: 1,
        page_size: 20,
        search: '',
        status: '',
    };

    const [filterData, setFilterData] = useState(initFilterData);

    const [data, setData] = useState([])
    const [products, setProducts] = useState([])
    const [variants, setVariants] = useState([])

    const handlePaginate = (args) => {
        setFilterData(prev => ({
            ...prev,
            page: args.page + 1,
            page_size: args.page_size
        }));
    };

    const getData = useCallback(async () => {
        const response = await GET('/recipes/boxes/', filterData);

        if (httpOk(response)) {
            setData(response.data);
        }
    }, [filterData]);

    useEffect(() => {
        getData();
    }, [getData]);

    const getProducts = useCallback(async () => {
        const response = await GET('/catalogs/products/');

        if (httpOk(response)) {
            setProducts(response.data);
        }
    }, []);

    useEffect(() => {
        getProducts();
    }, [getProducts]);

    const getVariants = useCallback(async () => {
        const response = await GET('/recipes/variants/', { product_id: filterData.product_id });

        if (httpOk(response)) {
            setVariants(response.data);
        }
    }, []);

    useDidMountEffect(() => {
        getVariants();
    }, [filterData.product_id]);


    return (
        <>
            <div className="d-between">
                <div>
                    <div className="main-content-title">
                        {t('boxes')}
                    </div>

                    <div className="main-content-subtitle">
                        {t('boxes_description')}
                    </div>
                </div>

                <button className="white gap-16" onClick={() => setCreateBoxModal({ show: true })}>
                    {t('Создать коробку')}
                </button>
            </div>

            <div className="card">
                <div className="d-flex gap-16 w-100">
                    <FilterSearch
                        value={filterData.search}
                        onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
                        placeholder={t('search_by_sku_or_name')}
                    />

                    <CustomSelect
                        options={products}
                        value={products.find(option => option.id === filterData?.product_id) || ''}
                        onChange={(option) => setFilterData({ ...filterData, product_id: option?.id })}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        placeholder={t("products")}
                    />

                    <CustomSelect
                        options={variants}
                        value={variants.find(option => option.id === filterData?.status) || ''}
                        onChange={(option) => setFilterData({ ...filterData, status: option?.id })}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        placeholder={t('variants')}
                    />
                </div>
            </div>

            <div className="card">
                <div className="d-between mb-30">
                    <div className="fz16 text-third">
                        {t('boxes')}
                    </div>
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: '10%' }}>{t('order_id')}</th>
                            <th style={{ width: '10%' }}>{t('product_code')}</th>
                            <th style={{ width: '10%' }}>{t('category')}</th>
                            <th style={{ width: '20%' }}>{t('name')}</th>
                            <th style={{ width: '10%' }}>{t('variant')}</th>
                            <th style={{ width: '10%' }}>{t('variant_weight')}</th>
                            <th style={{ width: '10%' }}>{t('type')}</th>
                            <th style={{ width: '10%' }}>{t('actions')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data?.map((item, index) => (
                            <tr key={index}>
                                <td>{item.id}</td>
                                <td>{item.product_code}</td>
                                <td>{item.product_category_name}</td>
                                <td>{item.product_name}</td>
                                <td>{item.variant_name}</td>
                                <td>{item.variant_weight}</td>
                                <td>{t(item.box_type)}</td>
                                <td>
                                    <div className="d-flex align-items-center gap-8">
                                        <button className="transparent small" onClick={() => setBoxDetailModal({ show: true, item: item })}>
                                            {t('details')}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <Pagination
                    paginate={handlePaginate}
                    pagination={{
                        total: data?.count || 0
                    }}
                />
            </div>

            <BoxDetail modal={boxDetailModal.show} setModal={() => setBoxDetailModal({ show: false })} data={boxDetailModal.item} />
            <CreateBox modal={createBoxModal.show} setModal={() => setCreateBoxModal({ show: false })} getData={getData} />
        </>
    )
}

export default Production